// extracted by mini-css-extract-plugin
module.exports = {"upload-wrap":"Upload_style_upload-wrap__HFJaf","other-item":"Upload_style_other-item__1_9ic"};